import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { PlanningClient } from './protogen/planning/ServiceServiceClientPb';
import { GetSprintDetailsRequest, GetSprintDetailsResponse, ListMySprintsRequest, ListMySprintsResponse } from './protogen/planning/service_pb';
import { SERVER } from './defaults';

@Injectable({
  providedIn: 'root'
})
export class SprintService {
  private service: PlanningClient = new PlanningClient(SERVER);
  constructor(private authService: AuthService) { }

  // TODO: Remove retrying.
  async getSprintDetails(sprintId: string, retrying: boolean = false):
      Promise<GetSprintDetailsResponse.AsObject> {
    try {
      const creds = await this.authService.getCreds();
      const id_token = creds.session_token;
      const request = new GetSprintDetailsRequest().setSprintId(sprintId);
      return (await this.service.getSprintDetails(request, { id_token })).toObject();
    } catch (err: any) {
      if (err.code === 16 && !retrying) {
        await this.authService.refresh();
        return this.getSprintDetails(sprintId, true);
      }
      throw err;
    }
  }

  // TODO: Remove retrying.
  async listMySprints(request: ListMySprintsRequest, retrying: boolean = false):
      Promise<ListMySprintsResponse.AsObject> {
    try {
      const creds = await this.authService.getCreds();
      const id_token = creds.session_token;
      return (await this.service.listMySprints(request, { id_token })).toObject();
    } catch (err: any) {
      if (err.code === 16 && !retrying) {
        await this.authService.refresh();
        return this.listMySprints(request, true);
      }
      throw err;
    }
  }
}
